var React = require('react');

function Keywee (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".keywee-icon-svg{fill:#2f4b76;}")),React.createElement("path",{"className":"keywee-icon-svg","d":"M3.47,3.78V1.52H8.4s0,.06,0,.09v9.16c0,.13,0,.16.16.16h1.3a.29.29,0,0,0,.26-.13L11.4,9.28l.6-.71H10.6c0-.07,0-.11,0-.16,0-.64,0-1.29,0-1.93,0-.14,0-.17.17-.17h5.49c.13,0,.18,0,.17.16v2c0,.05,0,.09,0,.15H15a.3.3,0,0,0-.27.12L14,9.62l-1.69,2c-.07.09-.06.12,0,.2a2.28,2.28,0,0,1,.5.48c.28.42.54.86.8,1.3.42.71.83,1.44,1.24,2.16a.77.77,0,0,0,.63.45l.43,0h.64v2.24h-.06c-.86,0-1.71,0-2.57,0a1.45,1.45,0,0,1-1.22-.56,4.08,4.08,0,0,1-.28-.44l-2.22-3.89a.73.73,0,0,0-.55-.4c-.36,0-.71,0-1.07-.06-.13,0-.17,0-.17.17v2.77c0,.05,0,.1,0,.17H9.69v2.24H3.61V16.23H5.36V3.78Z","key":1})]);
}

Keywee.defaultProps = {"id":"Layer_10","data-name":"Layer 10","viewBox":"0 0 20 20","width":"20","height":"20"};

module.exports = Keywee;

Keywee.default = Keywee;
